var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc113(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "14.0044mm",
    height: "9.107mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1221.95 794.63",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465255664688"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M846.8 233.16c0,-128.78 -104.39,-233.16 -233.16,-233.16 -128.78,0 -233.16,104.39 -233.16,233.16 0,128.78 104.39,233.16 233.16,233.16 128.78,0 233.16,-104.39 233.16,-233.16zm-204.08 -125.36l0 99.97 96.04 0 0 50.34 -96.98 0 0 99.04 -54.94 -0.01 0 -99.27 -96.28 0 0 -50.09 96.28 0 0 -99.97 55.87 0 0.01 -0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M914.68 794.63l-606.47 0 -308.21 -337.97 271.03 0 116.35 149.14 457.34 0 0 19.62 -467.03 0 -116.35 -149.38 -217.24 0 272.65 299.2 597.47 0 0.47 19.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.382845 -0.923813 0.923813 0.382845 303.435 781.118)",
    width: 183.07,
    height: 19.38
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.92388 -0.382683 0.382683 0.92388 826.467 619.252)",
    width: 19.38,
    height: 183.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M914.68 793.7l-14.32 -13.16 277.49 -304.51 -212.62 0 -118.2 145.68 -15.23 -12.24 124.2 -152.82 265.95 0 -307.27 337.05z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc113);
export default __webpack_public_path__ + "static/media/ic_1_13.a086a9c21f303c97d6ffaf4c9d3188e1.svg";
export { ForwardRef as ReactComponent };